import { ApiService } from './apiService'
import { baseApiUrl } from '../config'
import { AnonEvent, AnonEventFull } from '../types/Event'

const API_BASE = '/api/v3/events'
// Admin panel manages events on behalf of another company, so the admin endpoint requires a
// company_id query param (mirrors audienceLiftConversionService) - the plain endpoint infers it
// from the caller's own session.
const ADMIN_API_BASE = '/api/admin/v3/events'

export class EventService extends ApiService {
    constructor(baseUrl: string) {
        super(baseUrl)
    }

    async getEvents(): Promise<AnonEvent[]> {
        return this.get(API_BASE)
    }

    async getEventsAdmin(companyId: number): Promise<AnonEvent[]> {
        return this.get(`${ADMIN_API_BASE}?company_id=${companyId}`)
    }

    async getEventById(id: number): Promise<AnonEvent> {
        return this.get(`${API_BASE}/${id}`)
    }

    async getEventFull(id: number): Promise<AnonEventFull> {
        return this.get(`${API_BASE}/${id}/full`)
    }

    async createEvent(payload: Omit<AnonEvent, 'id' | 'createdAt' | 'updatedAt'>): Promise<AnonEvent> {
        return this.post(API_BASE, payload)
    }

    async updateEvent(id: number, payload: Omit<AnonEvent, 'id' | 'createdAt' | 'updatedAt'>): Promise<AnonEvent> {
        return this.put(`${API_BASE}/${id}`, payload)
    }

    async removeEvent(id: number): Promise<void> {
        return this.del(`${API_BASE}/${id}`)
    }
}

export const eventService = new EventService(baseApiUrl)
